import { render } from "./commessaTable.vue?vue&type=template&id=1995cc0b"
import script from "./commessaTable.vue?vue&type=script&lang=js"
export * from "./commessaTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__